import FormBuilder from "../../common/components/formInputs/FormBuilder";

function getCreateOrgFormInputs() {
  return [
    {
      type: "text",
      label: "Create your own organization",
      name: "organizationName",
      placeholder: "Organization name",
      validation: {
        required: "Organization name is required",
      },
    },
  ];
}

function getChooseOrgFormInputs(organizationOptions) {
  return [
    {
      type: "select",
      label: "Choose Organization",
      name: "organization",
      placeholder: "Choose Organization",
      validation: {
        required: "Please select an organization",
      },
      options: organizationOptions,
    },
  ];
}

export function getOrganizationOptions(
  organizationAsOwner,
  organizationsAsMember
) {
  const options = [];

  if (organizationAsOwner) {
    const { name, _id } = organizationAsOwner;

    options.push({
      label: `${name}`,
      value: _id,
    });
  }

  if (organizationsAsMember?.length) {
    organizationsAsMember.forEach((organization) => {
      const { name, _id } = organization?.organization || {};

      options.push({
        label: name,
        value: _id,
      });
    });
  }

  return options;
}

function OrganizationForm({
  createOrganization,
  isCreatingOrganization,
  organizationAsOwner,
  organizationsAsMember,
  onSelectingOrganization,
}) {
  const organizationOptions = getOrganizationOptions(
    organizationAsOwner,
    organizationsAsMember
  );

  return (
    <div className="bg-white rounded-md shadow-md p-8 text-gray-700 md:w-[450px]">
      {organizationOptions?.length ? (
        <div>
          <div className="font-bold text-center mb-8 text-2xl font-bold">
            Choose Organization
          </div>

          <ChooseOrganization
            onSubmit={(data) =>
              onSelectingOrganization(data?.organization?.value)
            }
            organizationOptions={organizationOptions}
          />
        </div>
      ) : null}

      {!organizationAsOwner && organizationsAsMember?.length ? (
        <div className="text-center  text-gray-500 flex items-center py-4">
          <div className="border-t border-gray-300 w-full h-2"></div>
          <div className="px-4 -mt-2">or</div>
          <div className="border-t border-gray-300 w-full h-2"></div>
        </div>
      ) : null}

      {organizationAsOwner ? null : (
        <div>
          <div className="font-bold text-center mb-8 text-2xl font-bold">
            Create Organization
          </div>

          <CreateOrganization
            onSubmit={createOrganization}
            isSubmitting={isCreatingOrganization}
          />
        </div>
      )}
    </div>
  );
}

export default OrganizationForm;

function CreateOrganization({ onSubmit, isSubmitting }) {
  return (
    <FormBuilder
      formInputs={getCreateOrgFormInputs()}
      submitButtonLabel="Create"
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
    />
  );
}

function ChooseOrganization({ onSubmit, isSubmitting, organizationOptions }) {
  return (
    <FormBuilder
      formInputs={getChooseOrgFormInputs(organizationOptions)}
      submitButtonLabel="Continue"
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
    />
  );
}
